import { FactoryOption } from './models/FactoryOption';

interface InitialState {
  list: FactoryOption[];
  loading: 'idle' | 'pending' | 'succeeded' | 'failed';
  listUpdatingCount: number;
  selectedItem: {
    data: FactoryOption | null;
    loading: 'idle' | 'pending' | 'succeeded' | 'failed';
  };
}

const initialState: InitialState = {
  list: [],
  loading: 'idle',
  listUpdatingCount: 0,

  selectedItem: {
    data: null,
    loading: 'idle',
  },
};

export default initialState;
